import React from 'react';
import {
  Flex,
  Text,
  Box,
} from '@chakra-ui/react';

/**
 * AgendaTabsNew - New tab design matching Figma
 * Shows Active and Past Agendas tabs with new styling
 */
const AgendaTabsNew = ({
  activeTab = 'active',
  onTabChange,
  tabs = [
    { id: 'active', label: 'Active', count: null },
    { id: 'past', label: 'Past Agendas', count: null },
  ],
  ...props
}) => {
  const handleTabClick = (tabId) => {
    if (onTabChange) {
      onTabChange(tabId);
    }
  };

  return (
    <Flex
      w="100%"
      // {...props}
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        
        return (
          <Flex
            key={tab.id}
            direction="column"
            align="center"
            gap="14px"
            flex="1"
            cursor="pointer"
            transition="all 0.2s"
            onClick={() => handleTabClick(tab.id)}
            data-testid={`tab-${tab.id}`}
            _hover={{
              opacity: isActive ? 1 : 0.8,
            }}
          >
            {/* Tab Text */}
            <Text
              fontSize="18px"
              fontWeight="700"
              color={isActive ? '#4C47CC' : '#726682'}
              lineHeight="1.333"
              textAlign="center"
              fontFamily="Geist, sans-serif"
              transition="color 0.2s"
            >
              {tab.label}
              {/* {tab.count !== null && ` (${tab.count})`} */}
            </Text>
            
            {/* Underline */}
            <Box
              w="100%"
              h={isActive ? "2px" : "1px"}
              bg={isActive ? '#4C47CC' : 'rgba(208, 204, 213, 0.3)'}
              transition="all 0.2s"
            />
          </Flex>
        );
      })}
    </Flex>
  );
};

export default AgendaTabsNew;
